var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.127 20.9351C15.6498 20.9351 20.127 16.4579 20.127 10.9351C20.127 5.41221 15.6498 0.935059 10.127 0.935059C4.60411 0.935059 0.126953 5.41221 0.126953 10.9351C0.126953 16.4579 4.60411 20.9351 10.127 20.9351Z",
    fill: "#00CC99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4568 10.9357C17.4568 11.4207 17.2018 11.8457 16.8268 12.0957L10.4868 17.1057C9.89175 17.5807 9.02175 17.4757 8.55175 16.8807C8.07675 16.2857 8.18175 15.4157 8.77675 14.9457L12.0968 12.3157H4.18175C3.41675 12.3157 2.79675 11.7007 2.79675 10.9357C2.79675 10.1707 3.41675 9.55065 4.18175 9.55065H12.1018L8.78175 6.92065C8.18675 6.45065 8.08175 5.58565 8.55675 4.98565C9.02675 4.39065 9.89675 4.28565 10.4918 4.76065L16.8268 9.77565C17.2018 10.0257 17.4568 10.4507 17.4568 10.9357Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.4a11fe9ad32289e8cca1d694d8f947bc.svg";
export { ForwardRef as ReactComponent };